/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppBar, Toolbar, IconButton, Menu } from '@material-ui/core';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@material-ui/styles';
import classNames from 'classnames';
import { Menu as MenuIcon, ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import Button from '@mui/material/Button';
import { getAllInstances } from '../../redux/Actions/instances.action';
import useStyles from './styles';
import { Typography } from '../Wrappers';
import sulogo from '../../assets/images/su-logo.png';
import { sideBarState } from '../../redux/Actions/sidebar.action';
import { logout } from '../../redux/Actions/login.action';

export default function Header(props) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const classes = useStyles();
    const instancePanel = props.sidebar;
    const sidebarStateValue = useSelector((state) => state.sidebar.isSideBarOpen);
    const [showSideBarToggle, setShowSideBarToggle] = useState(false);
    const [profileMenu, setProfileMenu] = useState(null);

    const signOut = () => {
        dispatch(logout(props.history));
    };

    const setSidebarOpened = (value) => {
        dispatch(sideBarState(value));
    };

    useEffect(() => {
        dispatch(getAllInstances({}));
        window.addEventListener('resize', handleWindowWidthChange);
        handleWindowWidthChange();
        return function cleanup() {
            window.removeEventListener('resize', handleWindowWidthChange);
        };
    }, [dispatch]);

    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                {showSideBarToggle && instancePanel ? (
                    <IconButton
                        color="inherit"
                        onClick={() => setSidebarOpened(!sidebarStateValue)}
                        className={classNames(
                            classes.headerMenuButtonSandwich,
                            classes.headerMenuButtonCollapse
                        )}
                    >
                        {sidebarStateValue ? (
                            <ArrowBackIcon
                                classes={{
                                    root: classNames(classes.headerIcon, classes.headerIconCollapse)
                                }}
                            />
                        ) : (
                            <MenuIcon
                                classes={{
                                    root: classNames(classes.headerIcon, classes.headerIconCollapse)
                                }}
                            />
                        )}
                    </IconButton>
                ) : (
                    ''
                )}
                <div className={classes.logotype}>
                    <Link to="/app/dashboard">
                        <img className={classes.logotypeIcon} src={sulogo} alt="logo" width="200" />
                    </Link>
                </div>
                <div className={classes.grow} />
                {instancePanel ? (
                    <Button
                        variant="outlined"
                        className={classes.headerMenuInstance}
                        onClick={() => {
                            props.history.push('/instances/list');
                        }}
                    >
                        All Instances
                    </Button>
                ) : (
                    <Button
                        className={classes.backToDashboardButton}
                        onClick={() => {
                            props.history.push('/app/dashboard');
                        }}
                    >
                        <ArrowBackIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                        Back to dashboard
                    </Button>
                )}
                {/* <IconButton
                    color="inherit"
                    aria-haspopup="true"
                    aria-controls="mail-menu"
                    onClick={(e) => {
                        setNotificationsMenu(e.currentTarget);
                        setIsNotificationsUnread(false);
                    }}
                    className={classes.headerMenuButton}
                >
                    <Badge
                        badgeContent={isNotificationsUnread ? '' : null}
                        color="warning"
                        className={classes.unreadBadge}
                    >
                        <FontAwesomeIcon
                            icon={faBell}
                            color="white"
                            className={classes.fontAwesomeIcon}
                            classes={{ root: classes.headerIcon }}
                        />
                    </Badge>
                </IconButton>
                <Menu
                    id="notifications-menu"
                    open={Boolean(notificationsMenu)}
                    anchorEl={notificationsMenu}
                    onClose={() => setNotificationsMenu(null)}
                    className={classes.headerMenu}
                    disableAutoFocusItem
                >
                    {notifications.map((notification) => (
                        <MenuItem
                            key={notification.id}
                            onClick={() => setNotificationsMenu(null)}
                            className={classes.headerMenuItem}
                        >
                            <Notification {...notification} typographyVariant="inherit" />
                        </MenuItem>
                    ))}
                </Menu> */}
                <IconButton
                    aria-haspopup="true"
                    color="inherit"
                    className={classes.headerMenuButton}
                    aria-controls="profile-menu"
                    onClick={(e) => setProfileMenu(e.currentTarget)}
                >
                    <FontAwesomeIcon
                        icon={faUserCircle}
                        color="white"
                        className={classes.fontAwesomeUserIcon}
                        classes={{ root: classes.headerIcon }}
                    />
                    <span className={classes.clientName}>
                        {Cookies.get('name') && Cookies.get('name').length > 0
                            ? Cookies.get('name')
                            : ''}
                    </span>
                </IconButton>
                <Menu
                    id="profile-menu"
                    open={Boolean(profileMenu)}
                    anchorEl={profileMenu}
                    onClose={() => setProfileMenu(null)}
                    className={classes.headerMenu}
                    classes={{ paper: classes.profileMenu }}
                    disableAutoFocusItem
                >
                    {/* <MenuItem
                        className={classNames(classes.profileMenuItem, classes.headerMenuItem)}
                    >
                        <AccountIcon className={classes.profileMenuIcon} /> Profile
                    </MenuItem> */}
                    <div className={classes.profileMenuUser}>
                        <Typography
                            className={classes.profileMenuLink}
                            color="primary"
                            onClick={signOut}
                        >
                            Sign Out
                        </Typography>
                    </div>
                </Menu>
            </Toolbar>
        </AppBar>
    );

    function handleWindowWidthChange() {
        const windowWidth = window.innerWidth;
        const breakpointWidth = theme.breakpoints.values.md;
        const isSmallScreen = windowWidth < breakpointWidth;

        if (isSmallScreen && !showSideBarToggle) {
            setShowSideBarToggle(true);
        } else if (!isSmallScreen && showSideBarToggle) {
            setShowSideBarToggle(false);
        }
    }
}
